<template>
  <div
    class="py-3 px-2"
    style="box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px; width: 100%"
  >
    <div class="px-0">
      <div class="row">
        <div class="col-12 appt-col-half mb-2">
          <div class="required">Tên lịch hẹn</div>
          <el-input
            v-model="formData.name"
            style="width: 100%"
            type="text"
            class="mt-1"
            placeholder="Nhập lịch hẹn"
            maxlength="250"
          />
        </div>
        <div class="col-12 appt-col-half mb-2">
          <div class="required">Người tham gia</div>
          <el-select
            filterable
            v-model="formData.participants"
            style="width: 100%"
            class="mt-1"
            placeholder="Tìm nhân viên"
            multiple
            collapse-tags
          >
            <el-option
              v-for="option in app.employeeList"
              :key="option.id"
              :label="option.username"
              :value="option.username"
            />
          </el-select>
        </div>
        <div class="col-12 appt-col-third mb-2">
          <div class="required">Ngày</div>
          <el-date-picker
            style="width: 100%"
            v-model="formData.time"
            class="mt-1"
            placeholder="Chọn ngày"
            format="dd/MM/yyyy"
          />
        </div>
        <div class="col-12 appt-col-third mb-2">
          <div class="required">Thời gian</div>
          <div class="d-flex gap-1">
            <el-time-picker
              v-model="formData.timeStart"
              placeholder="Từ"
              format="HH:mm"
              class="mt-1 flex-grow-1"
              style="min-width: 0"
            />
            <el-time-picker
              v-model="formData.timeEnd"
              placeholder="Đến"
              format="HH:mm"
              class="mt-1 flex-grow-1"
              style="min-width: 0"
            />
          </div>
        </div>
        <div class="col-12 appt-col-third mb-2">
          <div>Nhắc hẹn trước</div>
          <div class="d-flex">
            <el-input-number
              v-model="formData.timeNotify"
              controls-position="right"
              class="mt-1 flex-grow-1 me-1"
              style="min-width: 0"
            />
            <el-select
              v-model="formData.timeNotifyUnit"
              class="mt-1"
              placeholder="Chọn"
              popper-class="custom-select-popper"
              style="width: 90px; flex-shrink: 0"
            >
              <el-option
                v-for="(option, index) in options"
                :key="index"
                :label="option.name"
                :value="option.value"
              />
            </el-select>
          </div>
        </div>
        <div class="col-12 d-flex">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            class="mt-1 me-2 flex-grow-1"
            placeholder="Thêm ghi chú"
            v-model="formData.note"
          />
          <el-button
            size="small"
            class="mt-1"
            type="primary"
            @click="submit"
            :disabled="
              !this.formData.name.trim() ||
              !this.formData.participants ||
              !this.formData.time ||
              !this.formData.timeStart||
              !this.formData.timeEnd
            "
            >Tạo</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script >
import { HTTP } from "@/lib/http-common";
export default {
  props: ["contactId", "selectedContact"],
  data() {
    return {
      status: [],
      formData: {
        contactId: "",
        name: "",
        note: "",
        participants: "",
        time: "",
        timeStart: "",
        timeEnd: "",
        timeNotify: 30,
        timeNotifyUnit: "MINUTE",
      },
      options: [
        { name: "Phút", value: "MINUTE" },
        { name: "Giờ", value: "HOUR" },
        { name: "Ngày", value: "DAY" },
        { name: "Tháng", value: "MONTH" },
      ],
    };
  },

  methods: {
    calculateTsNotify(fromTime, timeNotify, timeNotifyUnit) {
      const time = timeNotify;
      let offset = 0;
      switch (timeNotifyUnit) {
        case "MINUTE":
          offset = time * 60 * 1000;
          break;
        case "HOUR":
          offset = time * 60 * 60 * 1000;
          break;
        case "DAY":
          offset = time * 24 * 60 * 60 * 1000;
          break;
        case "MONTH":
          offset = time * 24 * 60 * 60 * 1000 * 30;
          break;
      }

      return fromTime - offset;
    },
    combineDateAndTime(datePart, timePart) {
      const combined = new Date(datePart);
      combined.setHours(
        timePart.getHours(),
        timePart.getMinutes(),
        timePart.getSeconds(),
        timePart.getMilliseconds()
      );
      return combined.getTime();
    },

    async handleCreate(payload) {
      const res = await HTTP.post("/api/appointment/create", payload);
      if (res.status === "success") {
        this.alert("success", "Thêm lịch hẹn thành công");
        this.clearFormData();
        this.$emit("success");
      } else {
        this.$message.error("Không thể tạo lịch hẹn");
      }
    },
    updateAppointmentStatuses(response) {
      const now = new Date();
      const currentMinute = Math.floor(now.getTime() / (60 * 1000));
      response.forEach((appt) => {
        const startMinute = Math.floor(appt.timeStart / (60 * 1000));
        const endMinute = Math.floor(appt.timeEnd / (60 * 1000));
        let newStatus = appt.status;
        if (
          appt.status === "NOT_START" &&
          currentMinute >= startMinute &&
          currentMinute < endMinute
        ) {
          newStatus = "INPROCESS";
        }
        if (
          !["DONE", "CANCEL", "OVERTIME"].includes(appt.status) &&
          currentMinute >= endMinute
        ) {
          newStatus = "OVERTIME";
        }
        this.status.push(newStatus);
      });
    },
    async submit() {
      const fromTime = this.combineDateAndTime(
        this.formData.time,
        this.formData.timeStart
      );
      const toTime = this.combineDateAndTime(
        this.formData.time,
        this.formData.timeEnd
      );
      if (fromTime + 60000 > toTime  ) {
        this.$message.error(
          "Thời gian bắt đầu phải nhỏ hơn thời gian kết thúc."
        );
        return;
      }
      else{
        const tsNotify = this.calculateTsNotify(
        fromTime,
        this.formData.timeNotify,
        this.formData.timeNotifyUnit
      );
      const data = {
        contactId: this.selectedContact.id,
        timeStart: fromTime,
        timeEnd: toTime,
      };
      const payload = {
        contactId: this.selectedContact.id,
        contactName: this.selectedContact.displayName,
        contactPhone: this.selectedContact.phone,
        name: this.formData.name.trim(),
        note: this.formData.note.trim(),
        participants: JSON.stringify(this.formData.participants),
        timeStart: fromTime,
        timeEnd: toTime,
        timeNotify: this.formData.timeNotify,
        timeNotifyUnit: this.formData.timeNotifyUnit,
        tsNotify: tsNotify,
      };
      const response = await HTTP.post(
        "/api/appointment/check-duplicate",
        data
      );
      this.updateAppointmentStatuses(response.data);
      if (
        response.data.length > 0 &&
        this.status.filter((s) =>
          ["NOT_START", "INPROCESS", "OVERTIME"].includes(s)
        ).length > 0
      ) {
        try {
          await this.$confirm(
            `Lịch hẹn với khách hàng ${this.selectedContact.displayName} đã tồn tại trên hệ thống.
           Bạn có muốn tiếp tục không?`,
            "Xác nhận dữ liệu trùng",
            {
              confirmButtonText: "Tiếp tục",
              cancelButtonText: "Hủy",
              type: "warning",
              dangerouslyUseHTMLString: true,
            }
          );
          await this.handleCreate(payload);
        } catch (ex) {
          console.log("User cancelled confirmation", ex);
        }
      } else {
        await this.handleCreate(payload);
      }
      }
    },
    clearFormData() {
      this.formData = {
        name: "",
        note: "",
        time: null,
        timeStart: "",
        timeNotify: 30,
        timeNotifyUnit: "MINUTE",
        participants: this.app.user.type === "ADMIN" ? "" : [this.app.user.swUsername],
      };}
   },
  created() {
    if (this.app.user.type === "ADMIN") {
      this.formData.participants = "";
    } else {
      this.formData.participants = [this.app.user.swUsername];
    }
  },
};
</script>

<style scoped>
@media (min-width: 1801px) {
  .appt-col-half {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .appt-col-third {
    flex: 0 0 33.3333%;
    max-width: 33.3333%;
  }
}
</style>